
// error
export const NOTIFY_ERROR_EVENT = 'NOTIFY_ERROR_EVENT';
//snackbar
export const NOTIFY_SNACKBAR_EVENT = 'NOTIFY_SNACKBAR_EVENT';
export const HIDE_SNACKBAR_EVENT = 'HIDE_SNACKBAR_EVENT';
export const HIDE_ERROR_EVENT = 'HIDE_ERROR_EVENT';